<div *ngIf="selectedElement" (click)="closeMenu()" class="overlay">
    <div class="menu" [ngStyle]="{ top: menuPosition.top, left: menuPosition.left }" (click)="$event.stopPropagation()">
        <ul>
            <li *ngIf="!isResponsive" (click)="editarActividad()">Editar</li>
            <li *ngIf="isResponsive" (click)="editarActividadResponsive()">Editar</li>
            <li (click)="eliminarActividad(selectedElement)">Eliminar</li>
        </ul>
    </div>
</div>

<div (click)="closeFormResponsive()" *ngIf="isOpenFormResponsive" class="overlay-sheet">
    <div class="bottom-sheet" (click)="$event.stopPropagation()" [class.hidden]="isClosing">
        <button class="close-btn" (click)="closeFormResponsive()">✖</button>
        <h3>Nueva actividad</h3>
        <div class="form-actividad-sheet">
            <div class="form-act-column">
                <label>Nombre</label>
                <input type="text" [(ngModel)]="actividadResponsive.name" placeholder="Nombre de actividad">
            </div>
            <div class="form-act-column">
                <label>Descripción</label>
                <textarea [(ngModel)]="actividadResponsive.description" placeholder="Añade una descripción"
                    maxlength="200"
                    [class.char-limit-exceeded]="isCharacterLimitExceeded(actividadResponsive?.description || '', maxDescriptionLength)"
                    [class.char-limit-near]="isNearCharacterLimit(actividadResponsive?.description || '', maxDescriptionLength)">
                </textarea>
                <div class="character-counter">
                    <span
                        [class.counter-warning]="isNearCharacterLimit(actividadResponsive?.description || '', maxDescriptionLength)"
                        [class.counter-error]="isCharacterLimitExceeded(actividadResponsive?.description || '', maxDescriptionLength)">
                        {{ getCharacterCountText(actividadResponsive?.description || '', maxDescriptionLength) }}
                    </span>
                </div>
            </div>
            <div class="form-act-row">
                <div class="form-act-row-left">
                    <label>Status</label>
                </div>
                <div class="form-act-row-right">
                    <span class="estado">{{ actividadResponsive.state }}</span>
                </div>
            </div>

            <div class="form-act-row">
                <div class="form-act-row-left">
                    <label>Inicio</label>
                </div>
                <div class="form-act-row-right">
                    <app-custom-date-picker [(ngModel)]="actividadResponsive.start"
                        [minDate]="getActivityMinStartDate()" [maxDate]="getActivityMaxStartDate()"
                        (dateChange)="changeFechaActividadResponsive($event, 1)" placeholder="dd/mm/aaaa">
                    </app-custom-date-picker>
                    <div class="validation-message"
                        *ngIf="actividadResponsive.start && !validateActivityStartDate(actividadResponsive.start)">
                        ⚠️ Fecha debe estar entre {{ fechaInicioObjetivo }} y {{ fechaFinObjetivo }}
                    </div>
                </div>
            </div>
            <div class="form-act-row">
                <div class="form-act-row-left">
                    <label>Fin</label>
                </div>
                <div class="form-act-row-right">
                    <app-custom-date-picker [(ngModel)]="actividadResponsive.end" [minDate]="getActivityMinEndDate()"
                        [maxDate]="getActivityMaxEndDate()" (dateChange)="changeFechaActividadResponsive($event, 2)"
                        placeholder="dd/mm/aaaa">
                    </app-custom-date-picker>
                    <div class="validation-message"
                        *ngIf="actividadResponsive.end && !validateActivityEndDate(actividadResponsive.end)">
                        ⚠️ Fecha debe estar entre {{ fechaInicioObjetivo }} y {{ fechaFinObjetivo }}
                    </div>
                    <div class="validation-message"
                        *ngIf="actividadResponsive.start && actividadResponsive.end && !validateActivityDateRange(actividadResponsive.start, actividadResponsive.end)">
                        ⚠️ La fecha de fin debe ser posterior a la fecha de inicio
                    </div>
                </div>
            </div>
            <button class="add-btn" (click)="guardarActividadResponsive()">+ Añadir actividad</button>
        </div>
    </div>
</div>

<!-- Modal de confirmación -->
<div class="modal-overlay" *ngIf="mostrarModal" (click)="cerrarModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
        <div class="modal-icon">Tu progreso

            <div class="icon-circle">
                <span class="icon-x">✕</span>
            </div>
        </div>
        <h2 class="modal-title">¿Quieres salir sin guardar?</h2>
        <p class="modal-description">Los cambios que hiciste en tu objetivo se perderán si cierras ahora.</p>
        <div class="modal-actions">
            <button class="btn-exit" (click)="salirSinGuardar()">Salir sin guardar</button>
            <button class="btn-save-exit" (click)="guardarYSalir()">Continuar</button>
        </div>
    </div>
</div>

<!-- Modal de éxito -->
<div class="modal-overlay" *ngIf="mostrarModalExito" (click)="cerrarModalExito()">
    <div class="modal-content success-modal" (click)="$event.stopPropagation()">
        <div class="success-icon">
            <div class="success-circle">
                <div class="inner-circle">
                    <img src="assets/icons/success_objective.svg" alt="Success" class="icon-check">
                </div>
            </div>
            <div class="success-decorations">
                <div class="decoration decoration-1"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13"
                        viewBox="0 0 14 13" fill="none">
                        <path
                            d="M1.30012 11.9252C1.30012 11.9252 0.481877 7.06443 2.83015 6.09561C4.80293 5.2817 6.51325 8.88108 8.13425 7.57614C9.7762 6.25434 5.67736 4.16031 7.01223 2.57935C8.41713 0.915459 12.9283 2.57935 12.9283 2.57935"
                            stroke="#2F78EE"
                            style="stroke:#2F78EE;stroke:color(display-p3 0.1828 0.4713 0.9336);stroke-opacity:1;"
                            stroke-width="2.01707" />
                    </svg></div>
                <div class="decoration decoration-2"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="16"
                        viewBox="0 0 11 16" fill="none">
                        <path
                            d="M7.0681 7.64995C7.0681 11.8274 13.7639 15.214 9.1045 15.214C4.44513 15.214 0.667969 11.8274 0.667969 7.64995C0.667969 3.47246 4.44513 0.0859375 9.1045 0.0859375C13.7639 0.0859375 7.0681 3.47246 7.0681 7.64995Z"
                            fill="#FE964A"
                            style="fill:#FE964A;fill:color(display-p3 0.9961 0.5882 0.2902);fill-opacity:1;" />
                    </svg></div>
                <div class="decoration decoration-3"><svg xmlns="http://www.w3.org/2000/svg" width="37" height="40"
                        viewBox="0 0 37 40" fill="none">
                        <path d="M5.95473 10.6409L27.5611 21.3971L22.1608 28.7613L5.95473 10.6409Z" fill="#2F78EE"
                            style="fill:#2F78EE;fill:color(display-p3 0.1828 0.4713 0.9336);fill-opacity:1;" />
                    </svg></div>
                <div class="decoration decoration-4"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="11"
                        viewBox="0 0 11 11" fill="none">
                        <path
                            d="M5.23017 0L6.36232 3.4844H10.026L7.06203 5.63788L8.19418 9.12228L5.23017 6.9688L2.26616 9.12228L3.39831 5.63788L0.434306 3.4844H4.09802L5.23017 0Z"
                            fill="#FE964A"
                            style="fill:#FE964A;fill:color(display-p3 0.9961 0.5882 0.2902);fill-opacity:1;" />
                    </svg></div>
                <div class="decoration decoration-5"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="12"
                        viewBox="0 0 17 12" fill="none">
                        <path
                            d="M6.11649 6.50188C8.88748 6.78078 11.5808 2.56546 11.2698 5.65609C10.9587 8.74672 8.46019 11.0261 5.6892 10.7472C2.91821 10.4683 0.924048 7.73674 1.23512 4.64611C1.54619 1.55548 3.3455 6.22298 6.11649 6.50188Z"
                            fill="#2F78EE"
                            style="fill:#2F78EE;fill:color(display-p3 0.1828 0.4713 0.9336);fill-opacity:1;" />
                    </svg></div>
                <div class="decoration decoration-6"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13"
                        viewBox="0 0 13 13" fill="none">
                        <circle cx="6.2171" cy="6.29327" r="5.88312" fill="#FFEDEC"
                            style="fill:#FFEDEC;fill:color(display-p3 1.0000 0.9293 0.9250);fill-opacity:1;" />
                    </svg></div>
                <div class="decoration decoration-7"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="21"
                        viewBox="0 0 22 21" fill="none">
                        <path
                            d="M1.37893 13.6565C1.37893 13.6565 12.127 8.3032 14.5652 11.1091C15.9048 12.6505 16.9163 14.5176 15.7167 16.0345C14.7919 17.2038 13.4567 17.3529 11.8924 17.0781C8.57955 16.4963 8.6298 11.8959 9.95962 9.04671C11.7957 5.11289 21.5422 7.43482 21.5422 7.43482"
                            stroke="#0BA259"
                            style="stroke:#0BA259;stroke:color(display-p3 0.0436 0.6364 0.3491);stroke-opacity:1;"
                            stroke-width="2.01707" />
                    </svg></div>
            </div>
        </div>
        <h2 class="modal-title">¡Objetivo creado con éxito!</h2>
        <p class="modal-description">Cada meta comienza con un primer paso. ¡Sigue adelante!</p>
        <div class="modal-actions">
            <!-- <button class="btn-close" (click)="cerrarModalExito()">Cerrar</button> -->
            <button class="btn-save" (click)="guardarYContinuar()">Continuar</button>
        </div>
    </div>
</div>

<!-- Modal de confirmación de eliminación -->
<div class="modal-overlay" *ngIf="mostrarModalConfirmacionEliminacion" (click)="cerrarModalConfirmacionEliminacion()">
    <div class="modal-content delete-confirmation-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <div class="warning-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <path d="M24 4L44 40H4L24 4Z" fill="#FF6B6B" stroke="#FF6B6B" stroke-width="2" />
                    <path d="M24 20V28" stroke="white" stroke-width="3" stroke-linecap="round" />
                    <circle cx="24" cy="36" r="2" fill="white" />
                </svg>
            </div>
            <h2 class="modal-title">Confirmar eliminación</h2>
            <p class="modal-description">
                ¿Estás seguro de que deseas eliminar la actividad
                <strong>"{{ actividadAEliminar?.name }}"</strong>?
            </p>
            <p class="modal-warning">
                ⚠️ Esta acción no se puede deshacer.
            </p>
        </div>
        <div class="modal-actions">
            <button class="btn-cancel" (click)="cerrarModalConfirmacionEliminacion()">
                Cancelar
            </button>
            <button class="btn-delete" (click)="confirmarEliminacionActividad()">
                Eliminar
            </button>
        </div>
    </div>
</div>

<div class="objective-form">
    <div class="page-header">
        <div class="breadcrumb">
            <span>Objetivos</span>
            <span class="separator">></span>
            <span class="current">Nuevo Objetivo</span>
        </div>
    </div>

    <!-- Contenido scrolleable -->
    <div class="scrollable-content">
        <h1 class="form-title">Nuevo objetivo</h1>

        <div class="form-section">
            <div class="form-row">
                <div class="form-group">
                    <label class="field-label">Nombre del objetivo <span style="color: red">*</span></label>
                    <input type="text" [(ngModel)]="nombreObjetivo" placeholder="Ingrese nombre de objetivo"
                        class="form-input">
                </div>

                <div class="form-group">
                    <label class="field-label">Área de la vida a la que pertenece <span
                            style="color: red">*</span></label>
                    <div class="select-container">
                        <select [(ngModel)]="selectedValue" (change)="onSelectionChange($event)" class="form-select">
                            <option value="" disabled selected>Seleccione la dimensión que predomine</option>
                            <option *ngFor="let option of optionsDimensions" [value]="option.id">{{ option.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="form-group full-width">
                <label class="field-label">Descripción del objetivo <span style="color: red">*</span></label>
                <textarea [(ngModel)]="descripcionObjetivo" placeholder="Ingrese descripción" class="form-textarea"
                    required></textarea>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label class="field-label">Fecha de inicio <span style="color: red">*</span></label>
                    <div class="date-input-wrapper">
                        <input type="text" readonly autocomplete="off" inputmode="none" [value]="fechaInicioObjetivo"
                            [placeholder]="placeholderCalendar"
                            (click)="openModalCalendar('objective', 'start', getLimitRangeCalendarObjectiveStart())"
                            class="date-input">
                        <mat-icon class="calendar-icon"
                            (click)="openModalCalendar('objective', 'start', getLimitRangeCalendarObjectiveStart())">calendar_today</mat-icon>
                    </div>
                </div>

                <div class="form-group">
                    <label class="field-label">Fecha de fin <span style="color: red">*</span></label>
                    <div class="date-input-wrapper" [ngClass]="!fechaInicioObjetivo ? 'disabled' : ''">
                        <input type="text" readonly autocomplete="off" inputmode="none" [value]="fechaFinObjetivo"
                            [placeholder]="placeholderCalendar"
                            (click)="openModalCalendar('objective', 'end', getLimitRangeCalendarObjectiveEnd())"
                            class="date-input">
                        <mat-icon class="calendar-icon"
                            (click)="openModalCalendar('objective', 'end', getLimitRangeCalendarObjectiveEnd())">calendar_today</mat-icon>
                    </div>
                </div>
            </div>

            <div class="form-actions desktop-only">
                <button class="btn-close" (click)="mostrarModalConfirmacion()">Cerrar</button>
                <button class="btn-save" (click)="guardarObjetivo()" [disabled]="!canSaveObjective()"
                    [title]="!canSaveObjective() ? 'Completa todos los campos requeridos y asegúrate de que todas las actividades terminadas tengan evidencia' : ''">
                    Guardar
                </button>
            </div>

            <div class="activities-section">
                <h3 class="section-title">Actividades</h3>
                <p class="help-text">Dale vida a tu objetivo. Añade las actividades que te acercarán paso a paso a
                    cumplirlo.</p>
                <!-- <button type="button" (click)="debugActividades()" style="margin-bottom: 10px; padding: 5px 10px; background: #17a2b8; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 12px;">
                    Debug Actividades
                </button> -->

                <!-- Actividades existentes -->
                <div *ngFor="let actividad of actividades; let i = index" class="activity-card">
                    <div class="activity-card-header">
                        <div class="activity-toggle">
                            <span class="toggle-label">¿Marcar esta actividad como terminada?</span>
                            <div class="toggle-switch" [class.active]="actividad.completed"
                                (click)="toggleActivityCompletion(actividad)">
                                <div class="toggle-slider">
                                    <span class="toggle-icon" *ngIf="!actividad.completed">−</span>
                                </div>
                            </div>
                        </div>

                        <div class="separator-line"></div>

                        <div class="activity-title-section">
                            <h4 class="activity-title">Actividad {{i + 1}}</h4>
                        </div>
                    </div>

                    <div class="activity-card-content">
                        <div class="activity-form-row">
                            <div class="activity-field name-field">
                                <label class="field-label">Nombre de la actividad <span
                                        style="color: red">*</span></label>
                                <input type="text" readonly [(ngModel)]="actividad.name"
                                    placeholder="Ingrese nombre de objetivo" class="activity-input">
                            </div>

                            <div class="activity-field date-field">
                                <label class="field-label">Fecha de inicio <span style="color: red">*</span></label>
                                <div class="date-input-wrapper">
                                    <input type="text" readonly autocomplete="off" inputmode="none"
                                        [value]="actividad.start" [placeholder]="placeholderCalendar"
                                        class="date-input">
                                    <mat-icon class="calendar-icon">calendar_today</mat-icon>
                                </div>
                            </div>

                            <div class="activity-field date-field">
                                <label class="field-label">Fecha de fin <span style="color: red">*</span></label>
                                <div class="date-input-wrapper">
                                    <input type="text" readonly autocomplete="off" inputmode="none"
                                        [value]="actividad.end" [placeholder]="placeholderCalendar" class="date-input">
                                    <mat-icon class="calendar-icon">calendar_today</mat-icon>
                                </div>
                            </div>
                        </div>

                        <div class="validation-message date-range-validation"
                            *ngIf="actividad.start && actividad.end && !validateActivityDateRange(actividad.start, actividad.end)">
                            ⚠️ La fecha de fin debe ser posterior a la fecha de inicio
                        </div>

                        <div class="activity-field">
                            <label class="field-label">Descripción de la actividad <span
                                    style="color: red">*</span></label>
                            <textarea [(ngModel)]="actividad.description" readonly
                                placeholder="Ingrese descripción maximo 200 caracteres" class="activity-textarea"
                                maxlength="200"
                                [class.char-limit-exceeded]="isCharacterLimitExceeded(actividad?.description || '', maxDescriptionLength)"
                                [class.char-limit-near]="isNearCharacterLimit(actividad?.description || '', maxDescriptionLength)">
                            </textarea>
                            <div class="character-counter">
                                <span
                                    [class.counter-warning]="isNearCharacterLimit(actividad?.description || '', maxDescriptionLength)"
                                    [class.counter-error]="isCharacterLimitExceeded(actividad?.description || '', maxDescriptionLength)">
                                    {{ getCharacterCountText(actividad?.description || '', maxDescriptionLength) }}
                                </span>
                            </div>
                        </div>

                        <div class="activity-field">
                            <label class="field-label">Evidencia (Imagen o PDF) <span *ngIf="actividad.completed"
                                    class="required-asterisk">*</span></label>
                            <p class="field-label-description">Sube tu documento solo cuando hayas finalizado tu
                                actividad. Este archivo servirá como evidencia de tu progreso con esta actividad.</p>
                            <div *ngIf="actividad.completed && !actividad.evidence" class="evidence-info-message">
                                📎 <strong>Evidencia requerida:</strong> Para marcar la actividad como terminada, debes
                                subir una imagen o archivo PDF que demuestre la finalización de la tarea.
                            </div>
                            <div class="photo-upload-area"
                                [class.required]="actividad.completed && !actividad.evidence">
                                <input type="file" accept="image/*,application/pdf,.pdf"
                                    (change)="onEvidenceFileSelected($event, actividad)" #evidenceFileInput
                                    style="display: none;">

                                <div *ngIf="!actividad.evidence || actividad.evidence === ''" class="upload-placeholder"
                                    (click)="evidenceFileInput.click()">
                                    <mat-icon class="photo-icon">attach_file</mat-icon>
                                    <span class="upload-text">Haz clic para subir evidencia (Imagen o PDF)</span>
                                </div>

                                <div *ngIf="actividad.evidence" class="evidence-preview">
                                    <div class="evidence-thumbnail">
                                        <!-- Preview para imágenes -->
                                        <img *ngIf="getFileType(actividad.evidence) === 'image'"
                                            [src]="getEvidenceUrl(actividad.evidence)" alt="Evidencia"
                                            class="evidence-image" (error)="onImageError($event)">

                                        <!-- Preview para PDFs -->
                                        <div *ngIf="getFileType(actividad.evidence) === 'pdf'" class="pdf-preview"
                                            (click)="openPDFPreview(actividad.evidence)">
                                            <mat-icon class="pdf-icon">picture_as_pdf</mat-icon>
                                            <span class="pdf-filename">Archivo PDF</span>
                                        </div>

                                        <div class="evidence-overlay">
                                            <button type="button" class="change-evidence-btn"
                                                (click)="evidenceFileInput.click()" title="Cambiar archivo">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                            <button *ngIf="getFileType(actividad.evidence) === 'pdf'" type="button"
                                                class="download-evidence-btn"
                                                (click)="downloadPDF(actividad.evidence, 'evidencia-actividad.pdf')"
                                                title="Descargar PDF">
                                                <mat-icon>download</mat-icon>
                                            </button>
                                            <button type="button" class="remove-evidence-btn"
                                                (click)="removeEvidence(actividad)" title="Eliminar archivo">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="actividad.completed && !actividad.evidence" class="validation-warning">
                                ⚠️ <strong>Atención:</strong> La actividad está marcada como terminada. Sube una imagen
                                de evidencia para completar la tarea.
                            </div>
                        </div>
                    </div>

                    <!-- Botones de acción -->
                    <div class="action-buttons">
                        <button class="btn-eliminar" (click)="eliminarActividad(actividad)">
                            Eliminar
                        </button>
                    </div>
                </div>

                <!-- Formulario para nueva actividad -->
                <div class="activity-card" *ngIf="isNewActividad">
                    <div class="activity-card-header">
                        <!-- Toggle de actividad terminada -->
                        <!--div class="activity-toggle">
                            <span class="toggle-label">¿Marcar esta actividad como terminada?</span>
                            <div class="toggle-switch" [class.active]="activityForm.get('state')?.value === 'Realizado'"
                                (click)="toggleNewActivityState()">
                                <div class="toggle-slider">
                                    <span class="toggle-icon"
                                        *ngIf="activityForm.get('state')?.value !== 'Realizado'">−</span>
                                </div>
                            </div>
                        </div-->

                        <!-- Línea separadora -->
                        <!--div class="separator-line"></div-->

                        <!-- Título de la actividad -->
                        <div class="activity-title-section">
                            <h4 class="activity-title">Nueva Actividad</h4>
                        </div>
                    </div>

                    <form [formGroup]="activityForm" (ngSubmit)="guardarActividad()" class="activity-card-content">
                        <div class="activity-form-row">
                            <div class="activity-field name-field">
                                <label class="field-label">Nombre de la actividad <span
                                        style="color: red">*</span></label>
                                <input [maxlength]="maxNameLength" type="text" formControlName="name"
                                    placeholder="Ingrese nombre de objetivo máximo 100 caracteres"
                                    class="activity-input">
                                <div class="character-counter">
                                    <span
                                        [class.counter-warning]="isNearCharacterLimit(activityForm.get('name')?.value || '', maxNameLength)"
                                        [class.counter-error]="isCharacterLimitExceeded(activityForm.get('name')?.value || '', maxNameLength)">
                                        {{ getCharacterCountText(activityForm.get('name')?.value || '', maxNameLength)
                                        }}
                                    </span>
                                </div>
                            </div>

                            <div class="activity-field date-field">
                                <label class="field-label">Fecha de inicio <span style="color: red">*</span></label>
                                <div class="date-input-wrapper"
                                    [ngClass]="(!fechaInicioObjetivo || !fechaFinObjetivo) ? 'disabled' : ''">
                                    <input type="text" readonly autocomplete="off" inputmode="none"
                                        formControlName="start" [placeholder]="placeholderCalendar"
                                        (click)="fechaInicioObjetivo && fechaFinObjetivo && openModalCalendar('activity', 'start', getLimitRangeCalendarActivityStart())"
                                        class="date-input">
                                    <mat-icon class="calendar-icon"
                                        (click)="fechaInicioObjetivo && fechaFinObjetivo && openModalCalendar('activity', 'start', getLimitRangeCalendarActivityStart())">calendar_today</mat-icon>
                                </div>
                                <div class="validation-message" *ngIf="!fechaInicioObjetivo || !fechaFinObjetivo">
                                    ⚠️ Objetivo debe tener Fecha Inicio
                                </div>
                            </div>

                            <div class="activity-field date-field">
                                <label class="field-label">Fecha de fin <span style="color: red">*</span></label>
                                <div class="date-input-wrapper"
                                    [ngClass]="(!fechaInicioObjetivo || !fechaFinObjetivo || !activityForm.get('start')?.value ) ? 'disabled' : ''">
                                    <input type="text" readonly autocomplete="off" inputmode="none"
                                        formControlName="end" [placeholder]="placeholderCalendar"
                                        (click)="fechaInicioObjetivo && fechaFinObjetivo && openModalCalendar('activity', 'end', getLimitRangeCalendarActivityEnd())"
                                        class="date-input">
                                    <mat-icon class="calendar-icon"
                                        (click)="fechaInicioObjetivo && fechaFinObjetivo && openModalCalendar('activity', 'end', getLimitRangeCalendarActivityEnd())">calendar_today</mat-icon>
                                </div>
                                <div class="validation-message" *ngIf="!fechaInicioObjetivo || !fechaFinObjetivo">
                                    ⚠️ Objetivo debe tener Fecha Fin
                                </div>
                            </div>
                        </div>

                        <div class="activity-field">
                            <label class="field-label">Descripción de la actividad <span
                                    style="color: red">*</span></label>
                            <textarea formControlName="description"
                                placeholder="Ingrese descripción maximo 200 caracteres" class="activity-textarea"
                                maxlength="200"
                                [class.char-limit-exceeded]="isCharacterLimitExceeded(activityForm.get('description')?.value || '', maxDescriptionLength)"
                                [class.char-limit-near]="isNearCharacterLimit(activityForm.get('description')?.value || '', maxDescriptionLength)">
                             </textarea>
                            <div class="character-counter">
                                <span
                                    [class.counter-warning]="isNearCharacterLimit(activityForm.get('description')?.value || '', maxDescriptionLength)"
                                    [class.counter-error]="isCharacterLimitExceeded(activityForm.get('description')?.value || '', maxDescriptionLength)">
                                    {{ getCharacterCountText(activityForm.get('description')?.value || '',
                                    maxDescriptionLength) }}
                                </span>
                            </div>
                        </div>

                        <!--div class="activity-field">
                            <label class="field-label">Evidencia (Imagen o PDF) <span *ngIf="activityForm.get('state')?.value === 'Realizado'" class="required-asterisk">*</span></label>
                            <p class="field-label-description">Sube tu documento solo cuando hayas finalizado tu actividad. Este archivo servirá como evidencia de tu progreso con esta actividad.</p>
                            <div *ngIf="activityForm.get('state')?.value === 'Realizado'" class="evidence-info-message">
                                📎 <strong>Evidencia requerida:</strong> Para marcar la actividad como terminada, debes
                                subir una imagen o archivo PDF que demuestre la finalización de la tarea.
                            </div>
                            <div class="photo-upload-area"
                                [class.required]="activityForm.get('state')?.value === 'Realizado' && !selectedEvidenceFile">
                                <input type="file" accept="image/*,application/pdf,.pdf"
                                    (change)="onEvidenceFileSelected($event)" #evidenceFileInput style="display: none;">

                                <div *ngIf="!evidencePreviewUrl" class="upload-placeholder"
                                    (click)="evidenceFileInput.click()">
                                    <mat-icon class="photo-icon">attach_file</mat-icon>
                                    <span class="upload-text">Haz clic para subir evidencia (Imagen o PDF)</span>
                                </div>

                                <div *ngIf="evidencePreviewUrl" class="evidence-preview">
                                    <div class="evidence-thumbnail">
                                        <comment: Preview para imágenes>
                                        <img *ngIf="getFileType(evidencePreviewUrl) === 'image'"
                                            [src]="evidencePreviewUrl" alt="Evidencia" class="evidence-image"
                                            (error)="onImageError($event)">

                                        <comment: Preview para PDFs>
                                        <div *ngIf="getFileType(evidencePreviewUrl) === 'pdf'" class="pdf-preview"
                                            (click)="openPDFPreview(evidencePreviewUrl)">
                                            <mat-icon class="pdf-icon">picture_as_pdf</mat-icon>
                                            <span class="pdf-filename">{{ selectedEvidenceFile?.name || 'Archivo PDF'
                                                }}</span>
                                        </div>

                                        <div class="evidence-overlay">
                                            <button type="button" class="change-evidence-btn"
                                                (click)="evidenceFileInput.click()" title="Cambiar archivo">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                            <button *ngIf="getFileType(evidencePreviewUrl) === 'pdf'" type="button"
                                                class="download-evidence-btn"
                                                (click)="downloadPDF(evidencePreviewUrl, selectedEvidenceFile?.name || 'evidencia.pdf')"
                                                title="Descargar PDF">
                                                <mat-icon>download</mat-icon>
                                            </button>
                                            <button type="button" class="remove-evidence-btn" (click)="removeEvidence()"
                                                title="Eliminar archivo">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="evidence-info">
                                        <span class="evidence-name">{{ selectedEvidenceFile?.name || 'Archivo cargado'
                                            }}</span>
                                        <span class="evidence-size">{{ getFileSize(selectedEvidenceFile) }}</span>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="activityForm.get('evidence')?.invalid && activityForm.get('evidence')?.touched"
                                class="validation-error">
                                ❌ <strong>Evidencia requerida:</strong> Para marcar la actividad como terminada, debes
                                subir una imagen de evidencia.
                            </div>
                            <div *ngIf="activityForm.get('state')?.value === 'Realizado' && !selectedEvidenceFile"
                                class="validation-warning">
                                ⚠️ <strong>Atención:</strong> La actividad está marcada como terminada. Sube una imagen
                                de evidencia para poder guardar.
                            </div>
                        </div-->
                    </form>

                    <!-- Botones de acción -->
                    <div class="action-buttons">
                        <!-- Botones para nueva actividad (se muestran cuando se está editando) -->
                        <button *ngIf="isNewActividad" type="button" class="btn-guardar" (click)="guardarActividad()"
                            [disabled]="!canSaveActivity()"
                            [title]="!canSaveActivity() ? 'Completa todos los campos requeridos y sube evidencia si la actividad está terminada' : ''">
                            Guardar
                        </button>
                        <button *ngIf="isNewActividad" type="button" class="btn-cancelar"
                            (click)="cancelarEditableActividad()">
                            Cancelar
                        </button>

                        <!-- Botón eliminar (se muestra cuando la actividad ya está guardada) -->
                        <!--button *ngIf="!isNewActividad" class="btn-eliminar"
                            (click)="eliminarActividad(actividadEditable)">
                            Eliminar
                        </button-->
                    </div>
                </div>

                <button *ngIf="!isNewActividad" class="add-activity-button" (click)="agregarActividad()">+ Agregar
                    actividad</button>
            </div>
        </div>
    </div> <!-- Cierre del contenido scrolleable -->

    <!-- Footer fijo para móvil -->
    <div class="mobile-footer">
        <button class="btn-close" (click)="mostrarModalConfirmacion()">Cerrar</button>
        <button class="btn-save" (click)="guardarObjetivo()" [disabled]="!canSaveObjective()"
            [title]="!canSaveObjective() ? 'Completa todos los campos requeridos y asegúrate de que todas las actividades terminadas tengan evidencia' : ''">
            Guardar
        </button>
    </div>
</div>

<!-- Modal de evidencia -->
<div *ngIf="showEvidenceModal" class="evidence-modal-overlay">
    <div class="evidence-modal" (click)="$event.stopPropagation()">
        <div class="evidence-modal-header">
            <h3>Adjuntar Evidencia</h3>
            <button class="close-button" (click)="closeEvidenceModal()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="evidence-modal-body">
            <p class="evidence-description">
                Para completar la actividad "<strong>{{ currentActivity?.name }}</strong>"
                es necesario adjuntar una evidencia (imagen o PDF).
            </p>

            <div class="file-upload-area">
                <input type="file" #evidenceInput accept="image/*,application/pdf,.pdf"
                    (change)="onEvidenceFileSelected($event)" style="display: none;">

                <div class="upload-placeholder" (click)="evidenceInput.click()" [class.has-file]="evidenceFile">

                    <div *ngIf="!evidenceFile" class="placeholder-content">
                        <mat-icon class="upload-icon">attach_file</mat-icon>
                        <p>Haz clic para adjuntar evidencia</p>
                        <span>Imagen (JPG, PNG, GIF) o PDF</span>
                    </div>

                    <div *ngIf="evidenceFile" class="file-preview">
                        <!-- Preview para imágenes -->
                        <div *ngIf="evidencePreview && getFileType(evidencePreview) === 'image'" class="image-preview">
                            <div class="image-container">
                                <img [src]="evidencePreview" alt="Vista previa de imagen" />
                            </div>
                            <div class="file-info">
                                <p class="file-name">{{ evidenceFileName }}</p>
                                <div class="file-actions">
                                    <button class="change-file-btn"
                                        (click)="evidenceInput.click(); $event.stopPropagation()">
                                        <mat-icon>edit</mat-icon>
                                        Cambiar archivo
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Preview para PDF -->
                        <div *ngIf="evidencePreview && getFileType(evidencePreview) === 'pdf'" class="pdf-preview">
                            <div class="pdf-icon-container">
                                <mat-icon class="pdf-icon">picture_as_pdf</mat-icon>
                                <span class="pdf-label">Archivo PDF</span>
                            </div>
                            <div class="file-info">
                                <p class="file-name">{{ evidenceFileName }}</p>
                                <div class="file-actions">
                                    <button class="change-file-btn"
                                        (click)="evidenceInput.click(); $event.stopPropagation()">
                                        <mat-icon>edit</mat-icon>
                                        Cambiar archivo
                                    </button>
                                    <button class="download-file-btn"
                                        (click)="downloadEvidenceFile(); $event.stopPropagation()">
                                        <mat-icon>download</mat-icon>
                                        Descargar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="evidence-modal-footer">
            <button class="cancel-btn" (click)="closeEvidenceModal()" [disabled]="isUploading">
                Cancelar
            </button>
            <button class="complete-btn" (click)="confirmEvidenceAndComplete()"
                [disabled]="!evidenceFile || isUploading">
                <span *ngIf="!isUploading">Completar Actividad</span>
                <span *ngIf="isUploading">Guardando...</span>
            </button>
        </div>
    </div>
</div>

<!-- Modal Calendario -->
<div *ngIf="showModalCalendar" class="calendar-modal-overlay">
    <div class="calendar-modal-content" (click)="$event.stopPropagation()">
        <div class="calendar-header"></div>
        <div class="calendar-body">
            <mat-card class="custom-mat-card">
                <mat-calendar class="custom-mat-calendar" [selected]="modalCalendarValue"
                    [minDate]="limitsRangeCalendar.start" [maxDate]="limitsRangeCalendar.end" startView="multi-year"
                    (selectedChange)="onSelectedChange($event)" />
            </mat-card>
            <p style="margin-top: 15px;">Fecha Seleccionada: {{ modalCalendarValue | date:'dd/MM/yyyy' }}</p>
        </div>
        <div class="calendar-actions">
            <button class="btn-cancel" (click)="closeModalCalendar()">
                Cancelar
            </button>
            <button class="btn-confirm" [disabled]="modalCalendarValue == null" (click)="confirmModalCalendar()">
                Confirmar
            </button>
        </div>

    </div>
</div>